import { makeRootStyles } from "../../../theme/styles";

const useStyles = makeRootStyles(
  {
    errorBanner: {
      border: "1px solid #e02020",
      borderRadius: "4px",
      background: "#ffeded",
      color: "#000000",
      boxSizing: "border-box",
      padding: "16px",
      textAlign: "left",
      fontSize: "14px",
      lineHeight: "20px",
    },
  },
  { name: "N0ErrorBanner" },
);

export { useStyles };
